import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import { colors, fonts } from '../tokens'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: 1440,
    margin: '0 auto',
    padding: '40px 48px',
    display: 'flex',
    flexDirection: 'column',
    gap: '28px',
    fontFamily: fonts.ui,
    color: colors.navy,
    [theme.breakpoints.down('sm')]: {
      padding: '24px 16px',
    },
  },
  head: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    gap: '16px',
  },
  back: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    marginBottom: '6px',
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: colors.primary,
  },
  backIcon: {
    width: 14,
    height: 14,
  },
  title: {
    margin: 0,
    fontSize: '24px',
    fontWeight: 700,
    letterSpacing: '-0.02em',
    lineHeight: 1.25,
    color: colors.navy,
  },
  subtitle: {
    margin: '4px 0 0',
    fontSize: '14px',
    color: colors.muted,
  },
  action: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '10px 16px',
    border: 0,
    borderRadius: '8px',
    background: colors.primary,
    color: '#FFFFFF',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    fontFamily: 'inherit',
    fontSize: '14px',
    fontWeight: 500,
    '&:hover': {
      background: colors.primaryDark,
    },
  },
  actionIcon: {
    width: 16,
    height: 16,
  },
}))

/**
 * Standard page frame: back link, title, subtitle and a primary action.
 *
 * @param {{ label: string, onClick: Function }} [back]
 * @param {{ label: string, onClick: Function, icon?: string }} [action]
 * @param {React.ReactNode} [actionSlot] custom header action (replaces `action`)
 */
const AppPage = ({ title, subtitle, back, action, actionSlot, children }) => {
  const classes = useStyles()

  return (
    <main className={classes.root}>
      {/* The back link shows even before (or without) a title. */}
      {(title || back || subtitle || action || actionSlot) && (
        <div className={classes.head}>
          <div>
            {back && (
              <button
                type="button"
                className={classes.back}
                onClick={back.onClick}
              >
                <Icon icon="tabler:chevron-left" className={classes.backIcon} />
                {back.label}
              </button>
            )}
            {title && <h1 className={classes.title}>{title}</h1>}
            {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
          </div>
          {actionSlot}
          {!actionSlot && action && (
            <button
              type="button"
              className={classes.action}
              onClick={action.onClick}
            >
              <Icon
                icon={action.icon || 'tabler:plus'}
                className={classes.actionIcon}
              />
              {action.label}
            </button>
          )}
        </div>
      )}
      {children}
    </main>
  )
}

export default AppPage
